import Vue from "vue";
import css from "swiper/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
export default () => {
  Vue.use(VueAwesomeSwiper, { css });
};
